import { ReactNode } from 'react';
import { ArrowUpRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Magnetic } from '../Magnetic/Magnetic';
import './Button.css';

type Props = {
  children: ReactNode;
  variant?: 'primary' | 'ghost';
  href?: string;
  onClick?: () => void;
  icon?: boolean;
};

export function Button({ children, variant = 'primary', href, onClick, icon = true }: Props) {
  const inner = (
    <span className={`btn btn--${variant}`} onClick={onClick}>
      <span className="btn__label">{children}</span>
      {icon && (
        <span className="btn__icon">
          <ArrowUpRight size={18} strokeWidth={1.5} />
        </span>
      )}
      <span className="btn__glow" />
    </span>
  );

  const isInternal = href && href.startsWith('/');

  return (
    <Magnetic strength={0.2}>
      {href ? (
        isInternal ? (
          <Link to={href} className="btn-link">
            {inner}
          </Link>
        ) : (
          <a href={href} className="btn-link">
            {inner}
          </a>
        )
      ) : (
        inner
      )}
    </Magnetic>
  );
}
